import React from "react";
import { useLocation } from "react-router";
import StatusState from "../../components/StatusState";
import { AppRouteProps } from "../../App";
import { useSpsLanguage } from "@spscommerce/i18n";

export type ErrorRouteProps = Partial<AppRouteProps> & Pick<AppRouteProps, "redirectService">;

export function ErrorRoute({ redirectService }: ErrorRouteProps) {
    const { t } = useSpsLanguage();
    const params = new URLSearchParams(useLocation().search);
    const errorParam = params.has("error") ? params.get("error") : null;
    const descriptionParam = params.has("errorDescription")
        ? params.get("errorDescription")
        : undefined;
    const descriptionDisplay =
        descriptionParam ||
        t("cpauth.genericErrorDescription", {
            defaultValue:
                "Please go back and try again or contact support if the problem persists.",
        })!;
    if (errorParam) {
        console.error(errorParam);
    }
    function backToLogin() {
        redirectService.backToLogin();
    }
    return (
        <div className="auth-box">
            <div className="auth-logo">
                <div className="logo"></div>
            </div>
            <div className="auth-content">
                <StatusState
                    header={t("cpauth.oops", {
                        defaultValue: "Oops! We're Having a Problem on Our End",
                    })}
                    message={descriptionDisplay}
                    backToLogin={backToLogin}
                    imgSrc="/assets/image-error-6.svg"
                    alt="Error Status Icon"
                />
            </div>
        </div>
    );
}
